import { CSSProperties } from "react";
import { GroupBase, OptionProps } from "react-select";
import { DropdownListItem } from "../../../../../Dropdown";

export function Option<Option, IsMulti extends boolean, Group extends GroupBase<Option>>
(props: OptionProps<Option, IsMulti, Group>) {
  return (
    <DropdownListItem
      style={props.getStyles("option", props) as CSSProperties}
      {...props.innerProps}
      ref={props.innerRef}
      selected={props.isSelected}
      focused={props.isFocused}
      hovered={props.isFocused}
      disabled={props.isDisabled}
    >
      {props.children}
    </DropdownListItem>
  );
}